import React from 'react';
import ListVetRequest from '../../../components/vessel-info/vet-request-history/ListVetRquest';

export default function VetRquestListing() {
  return <ListVetRequest isFromVetRequestHistoryTab={false} />;
}
